import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

const SearchGroup = ({ hubListParams, setHubListParams }) => {
  const { t } = useTranslation(["hub"]);

  const categoriesListAllOptions = [
    {
      label: t("filter.all"),
      value: "",
    },
    {
      label: t("filter.category.is_hub"),
      value: "hub",
    },
    {
      label: t("filter.category.is_center"),
      value: "center",
    },
  ];

  const statusListAllOptions = [
    {
      label: t("filter.all"),
      value: "",
    },
    {
      label: t("filter.status.active"),
      value: "O",
    },
    {
      label: t("filter.status.un_active"),
      value: "C",
    },
  ];

  const [categoriesFilter, setCategoriesFilter] = useState(false);
  const [selectedCategoriesFilter, setSelectedCategoriesFilter] = useState("");

  const handleCategoriesFilter = categories => {
    const columnFilter = { ...hubListParams.columnFilter };

    if (categories.value === "hub") {
      setSelectedCategoriesFilter(categories?.label);
      columnFilter["filter[is_center]"] = 0;
    } else if (categories.value === "center") {
      setSelectedCategoriesFilter(categories?.label);
      columnFilter["filter[is_center]"] = 1;
    } else {
      setSelectedCategoriesFilter("");
      delete columnFilter["filter[is_center]"];
    }

    setHubListParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const [statusFilter, setStatusFilter] = useState(false);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("");

  const handleStatusFilter = status => {
    const columnFilter = { ...hubListParams.columnFilter };

    if (status.value !== "") {
      setSelectedStatusFilter(status?.label);
      columnFilter["filter[record_status]"] = status.value;
    } else {
      setSelectedStatusFilter("");
      delete columnFilter["filter[record_status]"];
    }

    setHubListParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  return (
    <>
      <div>
        <Dropdown
          isOpen={categoriesFilter}
          toggle={() => setCategoriesFilter(!categoriesFilter)}
        >
          <DropdownToggle className="btn primary-btn w-100" caret>
            {t("title.category")}
            {selectedCategoriesFilter && (
              <span>:&nbsp;{selectedCategoriesFilter}</span>
            )}
            <i className="mdi mdi-chevron-down" />
          </DropdownToggle>
          <DropdownMenu className="w-100">
            {categoriesListAllOptions?.length > 0 &&
              categoriesListAllOptions.map((categories, index) => (
                <DropdownItem
                  key={`categories-${index}`}
                  onClick={() => handleCategoriesFilter(categories)}
                >
                  {categories.label}
                </DropdownItem>
              ))}
          </DropdownMenu>
        </Dropdown>
      </div>
      <div>
        <Dropdown
          isOpen={statusFilter}
          toggle={() => setStatusFilter(!statusFilter)}
        >
          <DropdownToggle className="btn primary-btn w-100" caret>
            {t("table.status")}
            {selectedStatusFilter && <span>:&nbsp;{selectedStatusFilter}</span>}
            <i className="mdi mdi-chevron-down" />
          </DropdownToggle>
          <DropdownMenu className="w-100">
            {statusListAllOptions?.length > 0 &&
              statusListAllOptions.map((status, index) => (
                <DropdownItem
                  key={`status-${index}`}
                  onClick={() => handleStatusFilter(status)}
                >
                  {status.label}
                </DropdownItem>
              ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    </>
  );
};

export default SearchGroup;
